document.addEventListener("DOMContentLoaded", function () {
	const ourstory_swiper = new Swiper(".ourstory_swiper.swiper", {
		// ...他の設定...
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev"
		},
		effect: "fade",
		fadeEffect: {
			crossFade: true
		},
		pagination: {
			el: ".timeline-pagination_btn",
			clickable: true,
			renderBullet: function (index, className) {
				// 各スライドのdata-year属性を取得
				const slides = document.querySelectorAll(".swiper-slide");
				const year = slides[index]?.getAttribute("data-year") || "";
				// ドット＋年号テキスト
				return `<div class="${className}">
				<span class="dot"></span>
				<span class="year">${year}</span></div>`;
			}
		}
	});
});
